import apiService from "./apiService";
import AppConstants from "../appConstants";

class ClientService {
    getAllClient(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getClientDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CLIENTS_DETAIL}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerClient(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CLIENTS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteClient(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CLIENTS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CLIENTS_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    sync(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_SYNC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getExpiredClients(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_GET_EXPIRED, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    disableExpiredClients(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_DISABLE_EXPIRED, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    trasnformExpiredClientsToFree(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_EXPIRED_TO_FREE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getFilterRights(params, body) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CLIENTS_FILTER_RIGHTS, body, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUpdateClientProfile(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_UPDATE_CLIENT_PROFILE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    reportUpdateClientProfile(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_UPDATE_CLIENT_PROFILE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================
    
    getAllClientAccessSystem(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_ACCESS_SYSTEM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    reportClientAccessSystem(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_CLIENTS_ACCESS_SYSTEM_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getDeviceClientAccessSystem(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_DEVICE_ACCESS_SYSTEM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getBrowserClientAccessSystem(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_BROWSER_ACCESS_SYSTEM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getOperatingSystemClientAccessSystem(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_OPERATING_SYSTEM_ACCESS_SYSTEM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCountryClientAccessSystem(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CLIENTS_COUNTRY_ACCESS_SYSTEM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    sendFirstAccessEmail(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CLIENTS_SENDMAIL_FIRST_ACCESS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
}

export default new ClientService();
